<script lang="ts" setup>
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { DetailsCarItemData } from '@autobid/ui/types/Car'
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  car: DetailsCarItemData | PreviewItemData
  details: DetailsCarItemDetails
  taxPopupSlug?: string
}

const props = defineProps<Props>()

const { documents, startPrice } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ documents.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsParameters :parameters="details.documents">
          <template #after>
            <tr v-if="startPrice?.priceLabel" class="text-primaryDark">
              <td class="pt-4 text-lg font-semibold">
                {{ startPrice.priceLabel }}:
              </td>
              <td class="pt-4 text-lg md:text-xl lg:text-2xl">
                <CommonCalculatedPrice
                  class="font-bold"
                  :price="startPrice.price"
                />
              </td>
            </tr>
            <tr v-if="startPrice?.taxLabel">
              <td class="text-lg font-semibold">
                {{ startPrice.taxLabel }}:
              </td>
              <td class="text-lg font-bold">
                <ElementsCarVatLink
                  class="inline-block"
                  :car="car"
                  :label="startPrice.tax"
                  :tax-popup-slug="taxPopupSlug"
                />
              </td>
            </tr>
          </template>
        </SectionsDetailsElementsParameters>
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
